import { useSelector } from 'react-redux'
import { isFeatureEnabled } from 'helpers/features'

export const useFeatureFlag = name => {
  const flagData = useSelector(state => state.globalData?.flagData)

  return isFeatureEnabled(name, flagData)
}
